import React, {useEffect, useState} from 'react';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import Navbar from './navigation/Navbar';
import LoginPage from './pages/login/LoginPage';
import ManagerDashboard from './pages/dashboard/ManagerDashboard';
import LeftAppMenu from './navigation/LeftAppMenu';
import './styles/App.css';
import {ClearCookie, GetCookieInfo} from "./logic/CookieManager";
import WelcomePage from "./pages/login/WelcomePage";
import LoadingView from "./LoadingView";
import ClientsPage from "./pages/manager-pages/clients/ClientsPage";
import ClientPage from "./pages/manager-pages/clients/ClientPage";
import AssetsPage from "./pages/manager-pages/lookups/AssetsPage";
import AssetEditPage from "./pages/manager-pages/lookups/AssetEditPage";
import CountriesPage from "./pages/manager-pages/lookups/CountriesPage";
import CountryEditPage from "./pages/manager-pages/lookups/CountryEditPage";
import {LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import NationalitiesPage from "./pages/manager-pages/lookups/NationalitiesPage";
import NationalityEditPage from "./pages/manager-pages/lookups/NationalityEditPage";
import {CacheLookupsForClient, CacheLookupsForManager} from "./logic/LookupHelper";
import LimitEditPage from "./pages/manager-pages/clients/LimitEditPage";
import BanksPage from "./pages/manager-pages/lookups/BanksPage";
import BankEditPage from "./pages/manager-pages/lookups/BankEditPage";
import WalletEditPage from "./pages/manager-pages/clients/WalletEditPage";
import BankAccountEditPage from "./pages/manager-pages/clients/BankAccountEditPage";
import TransferEditPage from "./pages/manager-pages/clients/TransferEditPage";
import OrderEditPage from "./pages/manager-pages/clients/OrderEditPage";
import TradeEditPage from "./pages/manager-pages/clients/TradeEditPage";
import ManagerReportingPage from "./pages/manager-pages/reporting/ManagerReportingPage";
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import AgreementEditPage from "./pages/manager-pages/clients/AgreementEditPage";
import OwnBankAccountsPage from "./pages/manager-pages/own-accounts/OwnBankAccountsPage";
import OwnWalletsPage from "./pages/manager-pages/own-accounts/OwnWalletsPage";
import CompanyMemberEditPage from "./pages/manager-pages/clients/CompanyMemberEditPage";
import {CacheClientBundle, CacheClients, CacheManagerDashboard} from "./logic/DataProvider";
import {GetIsBlocked, GetRole} from "./logic/JwtExtractor";
import ProfilePage from "./pages/client-pages/ProfilePage";
import AgreementsPage from "./pages/client-pages/AgreementsPage";
import LimitsPage from "./pages/client-pages/LimitsPage";
import WalletsPage from "./pages/client-pages/WalletsPage";
import BankAccountsPage from "./pages/client-pages/BankAccountsPage";
import TransfersPage from "./pages/client-pages/TransfersPage";
import OrdersPage from "./pages/client-pages/OrdersPage";
import TradesPage from "./pages/client-pages/TradesPage";
import WalletRequestPage from "./pages/client-pages/WalletRequestPage";
import BankAccountRequestPage from "./pages/client-pages/BankAccountRequestPage";
import TransferRequestPage from "./pages/client-pages/TransferRequestPage";
import OrderRequestPage from "./pages/client-pages/OrderRequestPage";
import ClientDashboard from "./pages/dashboard/ClientDashboard";
import ClientTicketsPage from "./pages/ticketing/ClientTicketsPage";
import ClientTicketPage from "./pages/ticketing/ClientTicketPage";
import NewTicketPage from "./pages/ticketing/NewTicketPage";
import ManagerTicketsPage from "./pages/ticketing/ManagerTicketsPage";
import ManagerTicketPage from "./pages/ticketing/ManagerTicketPage";
import ClientReportingPage from "./pages/manager-pages/reporting/ClientReportingPage";
import LimitRequestPage from "./pages/client-pages/LimitRequestPage";
import ClientFilesPage from "./pages/files/ClientFilesPage";
import UsersPage from "./pages/manager-pages/users/UsersPage";
import NewUserPage from "./pages/manager-pages/users/NewUserPage";
import ActiveOrdersPage from "./pages/dashboard/pages/ActiveOrdersPage";
import LastTradesPage from "./pages/dashboard/pages/LastTradesPage";
import NotificationsPage from "./pages/dashboard/pages/NotificationsPage";
import RegistrationPage from "./pages/login/RegistrationPage";

const App = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [role, setRole] = useState();


    useEffect(() => {
        dayjs.extend(utc);

        const checkTokenValidity = async () => {
            const cookieInfo = GetCookieInfo('nplt');
            if (cookieInfo) {
                const { value } = cookieInfo;

                try {
                    const isValid = await tokenIsValid(value);
                    if (isValid) {
                        setIsLoggedIn(true);

                        const role = GetRole();
                        setRole(role);

                        let isBlocked = GetIsBlocked();

                        console.log(`role = ${role}, blocked = ${isBlocked}`);

                        function timeout(ms) {
                            return new Promise(resolve => setTimeout(resolve, ms));
                        }
                        //await timeout(3000);

                        if (role === 'Manager' || role === 'Admin') {
                            await loadManagerData();
                            setIsLoading(false);
                        } else if (role === 'Trader') {
                            // Действия для роли Trader
                        } else if (role === 'Client') {
                            await loadClientData();
                            setIsLoading(false);
                        } else {
                            console.error('Не удается распознать роль.');
                        }
                    } else {
                        ClearCookie('nplt');
                    }
                } catch (error) {
                    console.error('Ошибка при проверке валидности токена:', error);
                    setIsLoading(false);
                }
            } else {
                setIsLoading(false);
            }
        };

        const loadManagerData = async () => {
            await CacheLookupsForManager();
            await CacheClients();
            await CacheManagerDashboard();
        };

        const loadClientData = async () => {
            await CacheLookupsForClient();
            //await CacheCurrentClient();
            await CacheClientBundle();
        };

        const tokenIsValid = (token) => {
            return new Promise((resolve, reject) => {
                fetch(process.env.REACT_APP_VALIDATE_TOKEN_URL, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        token: token
                    }),
                })
                    .then((response) => {
                        if (response.ok) {
                            return response.json();
                        } else {
                            throw new Error('Ошибка при проверке валидности токена');
                        }
                    })
                    .then((data) => {
                        console.log(data.data);
                        resolve(data.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        };

        checkTokenValidity();
    }, [isLoggedIn]);

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Router>
            {isLoading ? (
                <LoadingView  />
            ) : (
                <div className="app-container">
                    <Navbar isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn} />

                    {(isLoggedIn && (role === 'Manager' || role === 'Admin')) && (
                        <div className="content-container">
                            <LeftAppMenu />
                            <div className="page-container">
                                <Routes>
                                    <Route path="/" element={<ManagerDashboard  />} />
                                    <Route path="/active-orders" element={<ActiveOrdersPage  />} />
                                    <Route path="/last-trades" element={<LastTradesPage  />} />
                                    <Route path="/notifications" element={<NotificationsPage  />} />

                                    <Route path="/login" element={<LoginPage isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn} />} />
                                    <Route path="/contacts/clients" element={<ClientsPage />} />
                                    <Route path="/contacts/clients/:clientId" element={<ClientPage />} />

                                    <Route path="/contacts/clients/:clientId/agreement" element={<AgreementEditPage />} />
                                    <Route path="/contacts/clients/:clientId/agreement/:agreementId" element={<AgreementEditPage />} />

                                    <Route path="/contacts/clients/:clientId/limit" element={<LimitEditPage />} />
                                    <Route path="/contacts/clients/:clientId/limit/:limitId" element={<LimitEditPage />} />

                                    <Route path="/contacts/clients/:clientId/company-member" element={<CompanyMemberEditPage />} />
                                    <Route path="/contacts/clients/:clientId/company-member/:memberId" element={<CompanyMemberEditPage />} />

                                    <Route path="/contacts/clients/:clientId/wallet" element={<WalletEditPage />} />
                                    <Route path="/contacts/clients/:clientId/wallet/:walletId" element={<WalletEditPage />} />

                                    <Route path="/contacts/clients/:clientId/bank-account" element={<BankAccountEditPage />} />
                                    <Route path="/contacts/clients/:clientId/bank-account/:bankAccountId" element={<BankAccountEditPage />} />

                                    <Route path="/contacts/clients/:clientId/transfer" element={<TransferEditPage />} />
                                    <Route path="/contacts/clients/:clientId/transfer/:transferId" element={<TransferEditPage />} />

                                    <Route path="/contacts/clients/:clientId/order" element={<OrderEditPage />} />
                                    <Route path="/contacts/clients/:clientId/order/:orderId" element={<OrderEditPage />} />

                                    <Route path="/contacts/clients/:clientId/trade" element={<TradeEditPage />} />
                                    <Route path="/contacts/clients/:clientId/trade/:tradeId" element={<TradeEditPage />} />

                                    <Route path="/lookups/assets" element={<AssetsPage />} />
                                    <Route path="/lookups/assets/edit/:assetId" element={<AssetEditPage />} />
                                    <Route path="/lookups/assets/edit" element={<AssetEditPage />} />

                                    <Route path="/lookups/countries" element={<CountriesPage />} />
                                    <Route path="/lookups/countries/edit/:countryId" element={<CountryEditPage />} />
                                    <Route path="/lookups/countries/edit" element={<CountryEditPage />} />

                                    <Route path="/lookups/nationalities" element={<NationalitiesPage />} />
                                    <Route path="/lookups/nationalities/edit/:nationalityId" element={<NationalityEditPage />} />
                                    <Route path="/lookups/nationalities/edit" element={<NationalityEditPage />} />

                                    <Route path="/lookups/banks" element={<BanksPage />} />
                                    <Route path="/lookups/banks/edit/:bankId" element={<BankEditPage />} />
                                    <Route path="/lookups/banks/edit" element={<BankEditPage />} />

                                    <Route path="/own-accounts/wallets" element={<OwnWalletsPage />} />
                                    <Route path="/own-accounts/wallets/edit/:walletId" element={<WalletEditPage />} />
                                    <Route path="/own-accounts/wallets/edit" element={<WalletEditPage />} />

                                    <Route path="/own-accounts/bank-accounts" element={<OwnBankAccountsPage />} />
                                    <Route path="/own-accounts/bank-accounts/edit/:bankAccountId" element={<BankAccountEditPage />} />
                                    <Route path="/own-accounts/bank-accounts/edit" element={<BankAccountEditPage />} />

                                    <Route path="/users" element={<UsersPage  />} />
                                    <Route path="/users/new" element={<NewUserPage  />} />

                                    <Route path="/reporting" element={<ManagerReportingPage  />} />
                                    <Route path="/tickets" element={<ManagerTicketsPage />} />
                                    <Route path="/tickets/:ticketId" element={<ManagerTicketPage />} />
                                </Routes>
                            </div>
                        </div>
                    )}
                    {(isLoggedIn && (role === 'Client')) && (
                        <div className="content-container">
                            <LeftAppMenu />
                            <div className="page-container">
                                <Routes>
                                    <Route path="/" element={<ClientDashboard  />} />
                                    <Route path="/login" element={<LoginPage isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn} />} />

                                    <Route path="/profile" element={<ProfilePage />} />
                                    <Route path="/agreements" element={<AgreementsPage />} />

                                    <Route path="/limits" element={<LimitsPage />} />
                                    <Route path="/limits/request" element={<LimitRequestPage />} />

                                    <Route path="/wallets" element={<WalletsPage />} />
                                    <Route path="/wallets/request" element={<WalletRequestPage />} />

                                    <Route path="/accounts" element={<BankAccountsPage />} />
                                    <Route path="/accounts/request" element={<BankAccountRequestPage />} />

                                    <Route path="/transfers" element={<TransfersPage />} />
                                    <Route path="/transfers/request/deposit" element={<TransferRequestPage />} />
                                    <Route path="/transfers/request/withdrawal" element={<TransferRequestPage />} />

                                    <Route path="/orders" element={<OrdersPage />} />
                                    <Route path="/orders/request" element={<OrderRequestPage />} />

                                    <Route path="/trades" element={<TradesPage />} />

                                    <Route path="/files" element={<ClientFilesPage />} />

                                    <Route path="/tickets" element={<ClientTicketsPage />} />
                                    <Route path="/tickets/:ticketId" element={<ClientTicketPage />} />
                                    <Route path="/tickets/new" element={<NewTicketPage />} />

                                    <Route path="/reporting" element={<ClientReportingPage  />} />
                                </Routes>
                            </div>
                        </div>
                    )}
                    {!isLoggedIn && (
                        <div className="content-container">
                            <div className="welcome-page-container">
                                <Routes>
                                    <Route path="/" element={<WelcomePage />} />
                                    <Route path="/login" element={<LoginPage isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn}
                                                                             isLoading={isLoading} setIsLoading={setIsLoading}/>} />
                                    <Route path="/registration" element={<RegistrationPage isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn}
                                                                             isLoading={isLoading} setIsLoading={setIsLoading}/>} />
                                </Routes>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </Router>
        </LocalizationProvider>
    );
};

export default App;
